import { render } from "./Footer_2024.vue?vue&type=template&id=23a354de&scoped=true"
import script from "./Footer_2024.vue?vue&type=script&lang=js"
export * from "./Footer_2024.vue?vue&type=script&lang=js"

import "./Footer_2024.vue?vue&type=style&index=0&id=23a354de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a354de"]])

export default __exports__